import { useEffect, useMemo } from "react";
import Match from "@/components/LichThiDauFull/Match";
import NoData from "@/components/NoData";
import { useLiveUpdates } from "@/hooks/useLiveUpdates";
import { useLiveData } from "@/hooks/useLiveData";
import useIsDesktop from "@/components/LichThiDauFull/useIsDesktop";
import { getRoundLabel } from "@/utils/leagueFixturesByLeague";

/**
 * @param {object} props
 * @param {object} props.league
 * @param {Array<[number|string, object[]]>} props.initialMatchesEntries
 */
export default function LeagueFixturesByLeagueList({
  league,
  initialMatchesEntries,
}) {
  const isDesktop = useIsDesktop();
  const { clearAllData } = useLiveData();
  const roundEntries = initialMatchesEntries || [];

  const matchIds = useMemo(() => {
    const ids = [];
    for (const [, matches] of roundEntries) {
      for (const m of matches ?? []) {
        const n = Number(m.id);
        if (Number.isFinite(n)) ids.push(n);
      }
    }
    return ids;
  }, [roundEntries]);

  useLiveUpdates(matchIds);

  useEffect(
    () => () => {
      clearAllData();
    },
    [clearAllData],
  );

  const totalMatches = useMemo(() => {
    let n = 0;
    for (const [, matches] of roundEntries) n += matches?.length ?? 0;
    return n;
  }, [roundEntries]);

  if (totalMatches === 0) {
    return <NoData message="Không có trận đấu" />;
  }

  return (
    <div className="rounded p-0 bg-[var(--theme-foreground,#fff)] overflow-hidden border border-[var(--theme-border,#e5e7eb)]">
      {roundEntries.map(([round, matches]) => (
        <div key={`${league?.id ?? ""}-${String(round)}`} className="kbv-ltd-league-group flex flex-col min-h-0">
          <div className="kbv-ltd-league-head">
            <h3 className="m-0 truncate text-sm font-semibold text-[var(--theme-text)]">
              {getRoundLabel(round, matches)}
            </h3>
          </div>
          <div className="flex flex-col min-h-0">
            {(matches || []).map((match, index) => (
              <Match
                key={match.id}
                match={match}
                horizontalLayout={isDesktop}
                isLastItem={index === matches.length - 1}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
